import { onContextChanged, publishAsk } from '../magpie/academyAssistantChannel';

/** Give up and drop the prompt if no video context shows up in time. */
const CONTEXT_WAIT_TIMEOUT_MS = 10000;

/**
 * Ask the assistant about content the user just clicked into, deferring the
 * prompt until the destination page reports its video context.
 *
 * Sending immediately on click races the navigation: the destination hasn't
 * mounted its player (and called `useAcademyAssistantContext`) yet, so
 * `sendMessageWithContext` would read an empty/stale context off the store and
 * the assistant would reply with no idea what video it's looking at. Instead
 * this waits for the next `contextChanged` broadcast that actually carries a
 * video (`catalogId`/`lessonId`) before publishing the `ask` — the old page's
 * own unmount broadcast is empty and is ignored. Gives up silently after
 * `CONTEXT_WAIT_TIMEOUT_MS` if the destination never reports one (e.g. the
 * content type doesn't play a video, or the navigation failed). The leftover
 * timer left running after an early resolve is harmless — the `settled` guard
 * no-ops it.
 */
export const askAboutUpcomingContent = (text, options) => {
  let settled = false;
  let unsubscribe = () => {};
  unsubscribe = onContextChanged(context => {
    if (settled || !context.catalogId && !context.lessonId) return;
    settled = true;
    unsubscribe();
    publishAsk(text, options);
  });
  setTimeout(() => {
    if (settled) return;
    settled = true;
    unsubscribe();
  }, CONTEXT_WAIT_TIMEOUT_MS);
};